<template>
  <Card
    class="border-l-4"
    :class="{
      'border-gray-50': loading,
      'border-green-500': !loading && queue.status === 'ok',
      'border-red-500': !loading && queue.status === 'warning'
    }"
  >
    <div v-if="loading">
      <Icon icon="spinner" spin class="text-3xl" />
    </div>

    <div v-else>
      <p class="text-xs font-medium uppercase tracking-wider">{{ title }}</p>
      <p class="mt-3 text-4xl font-semibold" :class="queue.count_status === 'warning' ? 'text-danger' : 'text-heading'">
        {{ queue.count | number }}
      </p>
      <p class="mt-2" :class="queue.age_status === 'warning' ? 'text-danger' : 'text-supplement'">
        Age: {{ queue.age || "Fresh" }}
      </p>
    </div>
  </Card>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    queue: {
      type: Object,
      required: true
    }
  }
}
</script>
